import React, { Component } from "react";
import axios from "axios";
import settings from "client.settings.json";
import "./addressPhoneForm.css";
import { translate } from "reducers/i18n";
import "react-phone-number-input/style.css";
import flags from "react-phone-number-input/flags";
import { connect } from "react-redux";
import CIcon from "@coreui/icons-react";
import { cilX } from "@coreui/icons";

import PhoneInput, {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { PageComponent } from "components/page";
import { getMappings } from "pages/getPageTemplatesMappings";

class AddressPhoneForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: "",
      addressIdIsValid: false,
      numberIsAddToAddress: false,
      error: null,
      retry: null,
      phoneNumberIsPossible: false,
      phoneNumberIsValid: false,
      phoneNumberHasFocus: false,
      mappings: {},
      placeholder: "",
      phoneNumberExists: false,
      addedNumbers: [],
      impossibleNumbers: [],
      invalidNumbers: [],
      severalNumbers: false,
      duplicateNumbers: [],
      blurEnabled: true,
    };
  }

  validateNumbers = () => {
    const checks = this.state.addedNumbers.map((number) => {
      const exists = (num) =>
        this.state.addedNumbers.filter((n) => n === num).length > 1;
      return {
        number: number,
        isPossible: number ? isPossiblePhoneNumber(number) : false,
        isValid: number ? isValidPhoneNumber(number) : false,
        duplicate: number ? exists(number) : false,
      };
    });
    this.setState({
      phoneNumberIsPossible: checks.map((c) => c.isPossible).every((b) => b),
      phoneNumberIsValid: checks.map((c) => c.isValid).every((b) => b),
      impossibleNumbers: checks
        .filter((c) => !c.isPossible)
        .map((c) => c.number),
      invalidNumbers: checks.filter((c) => !c.isValid).map((c) => c.number),
      duplicateNumbers: checks.filter((c) => c.duplicate).map((c) => c.number),
    });
  };

  handleBlur = () => {
    if (!this.state.blurEnabled) {
      this.setState({ phone: "" });
      return;
    }
    const exist = this.state.addedNumbers.includes(this.state.phone);

    this.setState({
      phoneNumberHasFocus: false,
      addedNumbers:
        this.state.phone && this.state.phone !== "" && !exist
          ? [...this.state.addedNumbers, this.state.phone]
          : this.state.addedNumbers,
      phoneNumberExists: exist,
      phone: "",
      blurEnabled: false,
    });

    setTimeout(() => {
      this.setState({ blurEnabled: true });
    }, 500);
  };

  componentDidMount() {
    this.validateAddressId();
    if (this.props.location.hash) {
      const nonce = this.props.location.hash.substring(1);
      this.setState({ nonce });
    }
    getMappings("addressess", this.props.match.params.tenantId)
      .then((mappings) =>
        this.setState({
          mappings: mappings,
          placeholder:
            mappings?.E_DELIVERY_NEW_PHONE_PAGE?.placeholder?.replace(
              /<\/?[^>]+(>|$)/g,
              ""
            ) || "",
        })
      )
      .catch((error) => console.log(error));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevState.addedNumbers) !==
      JSON.stringify(this.state.addedNumbers)
    ) {
      this.validateNumbers();
    }
    if (prevState.phone !== this.state.phone && !!this.state.phone.length) {
      this.setState({
        phoneNumberIsPossible: isPossiblePhoneNumber(
          String(this.state.phonenumber)
        ),
        phoneNumberIsValid: isValidPhoneNumber(String(this.state.phone)),
      });
    }

    if (prevProps.language !== this.props.language) {
      getMappings("addressess", this.props.match.params.tenantId)
        .then((mappings) => this.setState({ mappings: mappings }))
        .catch((error) => console.log(error));
    }
  }

  render() {
    const snippets = {
      "recipient email": this.state.email,
      "recepient email": this.state.email,
    };

    const btnFunctions = {
      E_DELIVERY_NEW_PHONE_PAGE: [this.sendPhone],
    };

    return (
      <div className="addressPhoneFormPage panel">
        {(() => {
          if (this.state.loading)
            return (
              <div className="panelContent body_fontFamily">
                <p>{translate("_isLoading")}...</p>
              </div>
            );
          else if (this.state.numberIsAddToAddress)
            return (
              <PageComponent
                content={
                  this.state.mappings["E_DELIVERY_NEW_PHONE_PAGE_CONFIRMED"]
                }
                snippets={snippets}
              />
            );
          else if (this.state.addressIdIsValid)
            return (
              <PageComponent
                content={this.state.mappings["E_DELIVERY_NEW_PHONE_PAGE"]}
                snippets={snippets}
                btnFunctions={btnFunctions["E_DELIVERY_NEW_PHONE_PAGE"]}
                // disabled={
                //   !(
                //     this.state.phoneNumberIsPossible ||
                //     this.state.phoneNumberIsValid
                //   )
                // }
              >
                <div
                  className={
                    this.state.phoneNumberHasFocus
                      ? "phoneNumberHasFocus"
                      : "phoneNumberHasNoFocus"
                  }
                >
                  <div
                    style={{ rowGap: ".25rem" }}
                    className={`PhoneInput ${
                      this.state.addedNumbers.length > 2 ? "flex-wrap" : ""
                    }`}
                  >
                    {this.state.addedNumbers.length > 0 &&
                      this.state.addedNumbers.map((number, i) => (
                        // incorrectNumber
                        <div
                          className={`addedNumber mr-1 ${
                            this.state.invalidNumbers.includes(number) ||
                            this.state.duplicateNumbers.includes(number)
                              ? "incorrectNumber"
                              : ""
                          }`}
                          key={i}
                        >
                          <PhoneInput
                            className="border border-0 p-0 m-0"
                            flags={flags}
                            defaultCountry="NL"
                            value={number}
                            onChange={(value) => {
                              const newNumbers = this.state.addedNumbers;
                              newNumbers[i] = value;
                              this.setState({ addedNumbers: newNumbers });
                            }}
                            onBlur={(e) => {
                              this.validateNumbers();
                            }}
                          />
                          <div
                            className={`remove ${
                              this.state.invalidNumbers.includes(number) ||
                              this.state.duplicateNumbers.includes(number)
                                ? "removeIncorrect"
                                : ""
                            } p-0 ml-1 d-flex align-items-center`}
                            color="secondary"
                            size="sm"
                            type="button"
                            onClick={() => {
                              this.setState({
                                addedNumbers: [
                                  ...this.state.addedNumbers.slice(0, i),
                                  ...this.state.addedNumbers.slice(i + 1),
                                ],
                              });
                            }}
                            variant="ghost"
                          >
                            <CIcon
                              className="fa-w-14 fa-fw mr-1 remove-svg"
                              icon={cilX}
                              style={{
                                marginRight: ".05rem !important",
                                marginLeft: ".10rem",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    <PhoneInput
                      className={`mb-0 ml-1 ${
                        this.state.addedNumbers.length < 3 ? "w-100" : ""
                      } border border-0`}
                      value={this.state.phone}
                      autoFocus
                      placeholder="06... of +316..."
                      defaultCountry="NL"
                      onChange={(value) => {
                        if (value) this.setState({ phone: value });
                        else
                          this.setState({
                            phone: "",
                            phoneNumberIsPossible: false,
                          });
                      }}
                      flags={flags}
                      onBlur={this.handleBlur}
                      onFocus={() => {
                        this.setState({ phoneNumberHasFocus: true });
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          this.handleBlur();
                        }
                      }}
                    />
                  </div>

                  <div className="PhoneNumberMessage">
                    {this.state.addedNumbers?.length > 0 &&
                    !this.state.phoneNumberHasFocus
                      ? this.state.phoneNumberExists ||
                        !!this.state.duplicateNumbers.length
                        ? translate("form_address_phone_exists")
                        : !this.state.phoneNumberIsValid
                        ? this.state.phoneNumberIsPossible
                          ? translate(
                              "form_address_phone_maynotcorrect",
                              this.state.invalidNumbers.join(", ")
                            )
                          : !!this.state.impossibleNumbers.length
                          ? this.state.impossibleNumbers.join(", ") === "" ||
                            this.state.impossibleNumbers.join(", ") === ", "
                            ? translate("form_address_phone_isempty")
                            : translate(
                                "form_address_phone_isnotcorrect",
                                this.state.impossibleNumbers.join(", ")
                              )
                          : ""
                        : ""
                      : ""}
                  </div>
                </div>
              </PageComponent>
            );
        })()}
      </div>
    );
  }

  validateAddressId = () => {
    this.setState({ loading: true });
    axios({
      url: `${settings.api}/api/public/address/${this.props.match.params.addressId}`,
      method: "get",
    }).then(
      (response) =>
        this.setState({
          loading: false,
          addressIdIsValid: true,
          email: response.data.email,
        }),
      (error) =>
        this.setState({
          loading: false,
          error: error,
          retry: () => {
            this.validateAddressId();
          },
        })
    );
  };

  sendPhone = () => {
    this.setState({ loading: true });
    axios({
      url: `${settings.api}/api/public/address/${this.props.match.params.addressId}/phone`,
      method: "put",
      data: { phone: this.state.addedNumbers.join(","), nonce: this.state.nonce },
    }).then(
      (response) =>
        this.setState({
          loading: false,
          numberIsAddToAddress: true,
          severalNumbers: this.state.addedNumbers.length > 1,
          addedNumbers: [],
        }),
      (error) =>
        this.setState({
          loading: false,
          error: error,
          retry: () => {
            this.validateAddressId();
          },
        })
    );
  };
}

const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(AddressPhoneForm);
